'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { VStack } from '@/components/Layout';
import { useSequenceSidebarData } from '@/routes/_chat/chat/$sessionId/-query';
import { Header } from '@/routes/_staff/cockpit/-components/header/header';
import { CockpitMockSidebar } from './-components/CockpitMockSidebar';
import { MockOperationTasks } from './-components/MockOperationTasks';
export const Route = createFileRoute('/_cockpit-mock/cockpit-mock/')({
  component: CockpitMockPage
});
function CockpitMockPage() {
  const sidebarData = useSequenceSidebarData('cockpit');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  return <div className="flex h-full min-h-0 w-full overflow-hidden bg-neutral-bottom-fill">
      <CockpitMockSidebar mode="cockpit" open={sidebarOpen} onToggle={() => setSidebarOpen(v => !v)} recentSessions={sidebarData.data?.recentSessions ?? []} upcomingInteractions={sidebarData.data?.upcomingInteractions ?? []} />
      <main className="min-w-0 flex-1 overflow-auto">
        <VStack className="justify-center items-center w-full">
          <Header />
          <MockOperationTasks />
        </VStack>
      </main>
    </div>;
}